import { Box, Button, styled } from "@mui/material";

export const groupInfoIconStyle = {
    color: "#3C77EF",
    height: "30px",
    width: "30px",
    border: " 1px solid #DCDCDD",
    borderRadius: "4px ",
    padding: "2px",
}

export const MyDetailsWrapper = styled(Box)({
    height: "100%",
    boxShadow: "0px 2px 8px #00000022",
    borderRadius: " 4px",
    opacity: 1,
})

export const GroupInfoHeader = styled(Box)({
    borderBottom: "1px solid #EFF0F5",
    padding: "20px",
    display: "flex",
    justifyContent: "space-between"
})

export const GroupInfoHeaderLeft = styled(Box)({
    display: "flex",
    justifyContent: "space-between"
})

export const GroupInfoHeaderIconWrapper = styled(Box)({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
})

export const GroupInfoHeaderIconActiveButton = styled(Button)({
    width: "60px",
    height: "18px",
    border: "1px solid #42B2A0",
    borderRadius: "4px",
    opacity: 1,
    color: "#42B2A0",
    backgroundColor: "#E6F8E9",
    fontSize: "10px",
    fontFamily: "Poppins",
})

export const GroupInfoContact = styled(Box)({
    padding: "20px",
    width: "100%",
    // height: "234px",
    borderBottom: "1px solid #EFF0F5",
    display: "flex",
    flexDirection: "column",
})

export const GroupInfoContactSectionOne = styled(Box)({
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "space-between",
    flexDirection: "row",
    // border: "1px solid red"
})

export const GroupInfoContactSectionOneLeft = styled(Box)({
    // border: "1px solid red"
})

export const GroupInfoContactSectionOneRight = styled(Box)({
    width: "50%",
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-around",
})

export const GroupInfoContactSectionTwo = styled(Box)({
    // width: "100%",
    // height: "100%",
    // display: "flex",
    // justifyContent: "space-between",
    // flexDirection: "row",
    // border: "1px solid red",
    // padding: "0px 0px 0px 33px",
    marginTop: "10px"
})

export const GroupInfoContactSectionThree = styled(Box)({
    // width: "100%",
    // height: "100%",
    // display: "flex",
    // justifyContent: "space-between",
    // flexDirection: "row",
    // border: "1px solid red",
    // padding: "0px 0px 0px 33px",
    marginTop: "10px"
})

export const GroupInfoAdvisor = styled(Box)({
    display: "flex",
    width: "100%",
    height: "100%",
    flexDirection: "row",
    // height: "104px",
    borderBottom: "1px solid #EFF0F5",
    padding: "20px",
    justifyContent: "space-between",
    // border: "1px solid red"
})

export const GroupInfoAdvisorLeft = styled(Box)({
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    // border: "1px solid red"
})

export const GroupInfoAdvisorRight = styled(Box)({
    // flex: 1,
    width: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-around",
    // border: "1px solid red"
})

export const GroupInfoRegion = styled(Box)({
    padding: "20px",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    borderBottom: "1px solid #EFF0F5",
})

export const GroupInfoRegionSectionOne = styled(Box)({
    display: "flex",
    flexDirection: "column",
    // width: "100%", 
    // height: "50%"
})

export const GroupInfoRegionSectionOneLeft = styled(Box)({
    // padding: "15px 0px 0px 33px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
})

export const GroupInfoRegionSectionTwo = styled(Box)({
    marginTop: "10px",
    display: "flex",
    justifyContent: "flex-start"
})

export const GroupInfoRegionSectionTwoLeft = styled(Box)({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
})

export const GroupInfoRegionSectionTwoRight = styled(Box)({
    flex: 1,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
})

export const GroupInfoDeactivate = styled(Box)({
    display: "flex",
    alignItems: "flex-start",
    padding: "20px"
})

export const GroupInfoDeactivateButton = styled(Button)({
    width: "138px",
    height: "40px",
    border: "1px solid #E48081",
    borderRadius: "4px",
    opacity: 1,
    color: "#F3797E",
    backgroundColor: "#E480811A",
    fontSize: "14px",
    textTransform: "capitalize",
    fontFamily: "Poppins",
})